import { blockType } from "../constants";
import { FormBlockSchema } from "../schema";
import { Form } from "../types";
import { create as createField } from "../../Field/lib/create";

export const create: Form["create"] = (initialConfig, children) => {
  return FormBlockSchema.parse({
    type: blockType,
    config: {
      ...initialConfig,
      submitText: initialConfig?.submitText ?? "Submit",
      triggers:
        Array.isArray(initialConfig?.triggers) && initialConfig?.triggers.length
          ? initialConfig.triggers
          : [
              {
                type: "notification",
                config: { position: "top-center", message: "Form submitted!" },
              },
            ],
      style: {
        ...initialConfig?.style,
        width: initialConfig?.style?.width ?? "narrow",
        alignment: initialConfig?.style?.alignment ?? "center",
      },
    },
    children: children?.length ? children : [createField()],
  });
};
